import { gql } from 'graphql-tag'
import { fragmentModuleNavigationLink } from '../../../../core/data-layer/modules/fragments'
import { fragmentGlobalDataTheme } from '../../../../core/data-layer/global-data/fragments'

export default gql`
  ${fragmentModuleNavigationLink}
  ${fragmentGlobalDataTheme}
  fragment BlockIndexHighlightFragment on BlockIndexHighlight {
    sys {
      id
    }
    title
    text {
      json
    }
    isFullScreen
    link {
      ...ModuleNavigationLinkFragment
    }
    theme {
      ...GlobalDataThemeFragment
    }
  }
`
